/**
 * Cómo se mira esta pantalla: días cerrados y cuántas tarjetas caben.
 */
export const CLAVE_OCULTAR_CERRADOS = 'agendify.horarios.ocultarCerrados'
export const CLAVE_COLUMNAS = 'agendify.horarios.columnas'
export const CLAVE_OCULTOS = 'agendify.horarios.ocultos'

export type ColumnasTarjetas = 'auto' | '2' | '3' | '4'

export function esColumnas(v: string | null): v is ColumnasTarjetas {
    return v === 'auto' || v === '2' || v === '3' || v === '4'
}

export function leerOcultarCerrados(): boolean {
    try {
        return localStorage.getItem(CLAVE_OCULTAR_CERRADOS) !== '0'
    } catch {
        return true
    }
}

export function recordarOcultarCerrados(v: boolean): void {
    try {
        localStorage.setItem(CLAVE_OCULTAR_CERRADOS, v ? '1' : '0')
    } catch {
        /* modo privado */
    }
}

export function leerColumnasTarjetas(): ColumnasTarjetas {
    try {
        const g = localStorage.getItem(CLAVE_COLUMNAS)
        if (esColumnas(g)) return g
    } catch {
        /* modo privado */
    }
    return 'auto'
}

export function recordarColumnasTarjetas(v: ColumnasTarjetas): void {
    try {
        localStorage.setItem(CLAVE_COLUMNAS, v)
    } catch {
        /* modo privado */
    }
}

export function claveOcultos(accountId: string): string {
    return `${CLAVE_OCULTOS}.${accountId}`
}

export function leerOcultos(accountId: string): number[] {
    try {
        const g = localStorage.getItem(claveOcultos(accountId))
        if (!g) return []
        const a = JSON.parse(g) as unknown
        if (!Array.isArray(a)) return []
        return a.filter((n): n is number => Number.isInteger(n))
    } catch {
        return []
    }
}

export function recordarOcultos(accountId: string, ids: readonly number[]): void {
    try {
        localStorage.setItem(claveOcultos(accountId), JSON.stringify([...ids]))
    } catch {
        /* modo privado */
    }
}

export function claseGridTarjetas(v: ColumnasTarjetas): string {
    switch (v) {
        case '2':
            return 'grid grid-cols-1 gap-2 md:grid-cols-2'
        case '3':
            return 'grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3'
        case '4':
            return 'grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-4'
        default:
            return 'grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-4'
    }
}
